import { webApi } from '@mi-front/api-clients';

/** Poll interval while at least one edit has `renderJob.isPending`. */
const VIDEO_EDITIONS_EDIT_LIST_REFETCH_MS = 5000;

/**
 * Lists video editor edits for a composition; refetches on an interval only while a render job is pending.
 */
export function useCompositionVideoEditionsEditsQuery(compositionId: string) {
  return webApi.useGetCompositionsDetailEdits(compositionId, {
    query: {
      refetchInterval: (query) => {
        const data = query.state.data;
        if (!data?.length) return false;
        return data.some((edit) => edit.renderJob?.isPending === true)
          ? VIDEO_EDITIONS_EDIT_LIST_REFETCH_MS
          : false;
      },
    },
  });
}
